import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DocumentTypeComponent } from "./document-type/documentType.component";
import { DocumentComponent } from "./documents/document.component";
import { OrganizationComponent } from "./organization/organization.component";
import { AgentComponent } from "./service - Copy/agent.component";
import { ServiceProviderComponent } from "./service-provider/serviceProvider.component";
import { ServiceComponent } from "./service/service.component";
import { UsersComponent } from "./users/users.component";
import { UserProfessionComponent } from "./userProfession/userProfession.component";
import { ShippingMethodComponent } from "./shipping-method/shipping-method.component";



export const routes: Routes = [
  { path: '', component: UsersComponent },
  { path: 'users', component: UsersComponent },
  { path: 'orgs', component: OrganizationComponent},
  { path: 'services', component: ServiceComponent},
  { path: 'agents', component: AgentComponent },
  { path: 'serviceProviders', component: ServiceProviderComponent },
  { path: 'documents', component: DocumentComponent },
  { path: 'documents/type', component: DocumentTypeComponent},
  { path: 'profession', component: UserProfessionComponent},
  { path: 'shippingMethods', component: ShippingMethodComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
